import React, { Component } from "react"
import { Switch, Route } from "react-router-dom"
import "./App.css"
import LandingPage from "pages/LandingPage"
import InfoPage from "pages/InfoPage"
import CompanyIndex from "pages/CompanyIndex"
import CompanyShow from "pages/CompanyShow"
import Companies from "pages/Admin/Companies/CompanyIndex"
import LoginPage from "pages/LoginPage"
import CompanyEdit from "pages/Admin/Companies/CompanyEdit"
import CompanySearch from "pages/CompanySearch"
import CompanyNew from "pages/Admin/Companies/CompanyNew"
import Categories from "pages/Admin/Categories/CategoryIndex"
import CategoryEdit from "pages/Admin/Categories/CategoryEdit"
import CategoryNew from "pages/Admin/Categories/CategoryNew"
import Ads from "pages/Admin/Ads/AdIndex"
import AdEdit from "pages/Admin/Ads/AdEdit"
import AdNew from "pages/Admin/Ads/AdNew"
import PrivateRoute from "utils/PrivateRoute"
import Contact from "pages/Contact"
import HttpsRedirect from 'react-https-redirect';
import "normalize.css"
import "styles/globals.scss"
import "icons"

class App extends Component {
  render() {
    return (
      <HttpsRedirect>
      <Switch>
        <Route exact={true} path="/infopage" component={InfoPage} />
        <Route exact={true} path="/contact" component={Contact} />
        <Route
          exact={true}
          path="/counties/:countyId/categories/:categoryId/companies"
          component={CompanyIndex}
        />
        <Route
          exact={true}
          path="/companies/:id/"
          component={CompanyShow}
        />
        <Route
          exact={true}
          path="/companies/:companyId"
          component={CompanySearch}
        />
        <PrivateRoute
          exact={true}
          path="/admin"
          guestOnly={true}
          redirectTo="/admin/companies"
          component={LoginPage}
        />
        <Route exact={true} path="/" component={LandingPage} />
        <PrivateRoute
          exact={true}
          path="/admin/companies/:id/edit"
          component={CompanyEdit}
        />
        <PrivateRoute
          exact={true}
          path="/admin/categories/:id/edit"
          component={CategoryEdit}
        />
        <PrivateRoute
          exact={true}
          path="/admin/categories/new"
          component={CategoryNew}
        />
        <PrivateRoute
          exact={true}
          path="/admin/companies/new"
          component={CompanyNew}
        />
        <PrivateRoute exact={true} path="/admin/ads" component={Ads} />
        <PrivateRoute
          exact={true}
          path="/admin/ads/new"
          component={AdNew}
        />
        <PrivateRoute
          exact={true}
          path="/admin/ads/:id/edit"
          component={AdEdit}
        />
        <PrivateRoute
          exact={true}
          path="/admin/categories"
          component={Categories}
        />
        <PrivateRoute
          exact={true}
          path="/admin/companies"
          component={Companies}
        />
      </Switch>
      </HttpsRedirect>
    )
  }
}

export default App



// WEBPACK FOOTER //
// src/App.jsx